export default __webpack_public_path__ + "static/media/checkIn1.fefbda93.svg";